module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_book.jpg",
      "width": 140,
      "height": 200,
      "avatar": false
    },
    model: {
      value: (_vm.book.image),
      callback: function($$v) {
        _vm.$set(_vm.book, "image", $$v)
      },
      expression: "book.image"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_title",
      "errors": _vm.errorBag.collect('book_title')
    },
    model: {
      value: (_vm.book.title),
      callback: function($$v) {
        _vm.$set(_vm.book, "title", $$v)
      },
      expression: "book.title"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_author",
      "errors": _vm.errorBag.collect('book_author')
    },
    model: {
      value: (_vm.book.author),
      callback: function($$v) {
        _vm.$set(_vm.book, "author", $$v)
      },
      expression: "book.author"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_description",
      "errors": _vm.errorBag.collect('book_description'),
      "crows": 15
    },
    model: {
      value: (_vm.book.description),
      callback: function($$v) {
        _vm.$set(_vm.book, "description", $$v)
      },
      expression: "book.description"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_publisher",
      "errors": _vm.errorBag.collect('book_publisher')
    },
    model: {
      value: (_vm.book.publisher),
      callback: function($$v) {
        _vm.$set(_vm.book, "publisher", $$v)
      },
      expression: "book.publisher"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_categories",
      "errors": _vm.errorBag.collect('book_categories')
    },
    model: {
      value: (_vm.book.categories),
      callback: function($$v) {
        _vm.$set(_vm.book, "categories", $$v)
      },
      expression: "book.categories"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_language",
      "errors": _vm.errorBag.collect('book_language'),
      "values": _vm.$config.lists.languages
    },
    model: {
      value: (_vm.book.language),
      callback: function($$v) {
        _vm.$set(_vm.book, "language", $$v)
      },
      expression: "book.language"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3af5efd2!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/BookEdit.vue
// module id = 650
// module chunks = 1